module.exports = __webpack_public_path__ + "img/symbol-3.25f9c4dc.svg";